export const projectsMenuEvents = {
    open: 'wallforming-projects-open',
    openLoad: 'wallforming-projects-open-load',
    openSave: 'wallforming-projects-open-save',
    triggerSave: 'wallforming-projects-trigger-save',
    toggleAutosave: 'wallforming-projects-toggle-autosave',
    stateChanged: 'wallforming-projects-state-changed'
} as const;